export const FOTO = "/images/delivery.jpg";

export const DELIVERY = {
  /* Urutan di sini menentukan urutan kartunya di halaman. */
  telepon: [
    {
      label: { id: "Apotek RS JMC", en: "JMC Pharmacy" },
      tampil: "0811-940-534",
      tel: "+62811940534",
      wa: "62811940534",
      pesanWa: {
        id: "Halo Apotek RS Jakarta Medical Center,\n\nSaya ingin memesan layanan delivery obat.\n\nMohon informasinya. Terima kasih.",
        en: "Hello RS Jakarta Medical Center pharmacy,\n\nI would like to order the medicine delivery service.\n\nThank you for your help.",
      },
      utama: true,
    },
    {
      label: { id: "Customer Service", en: "Customer Service" },
      tampil: "0811-901-874",
      tel: "+62811901874",
      wa: "62811901874",
      pesanWa: {
        id: "Halo RS Jakarta Medical Center,\n\nSaya ingin menanyakan mengenai layanan delivery obat.\n\nMohon bantuannya. Terima kasih.",
        en: "Hello RS Jakarta Medical Center,\n\nI would like to ask about the medicine delivery service.\n\nThank you for your help.",
      },
      utama: false,
    },
    {
      label: { id: "Hunting", en: "Main line" },
      tampil: "(021) 798 0888",
      tel: "+62217980888",
      utama: false,
    },
  ],
};

export const BIAYA = [
  {
    jarak: { id: "Sampai 5 km", en: "Up to 5 km" },
    tarif: { id: "Gratis", en: "Free" },
    gratis: true,
  },
  {
    jarak: { id: "5 - 10 km", en: "5 - 10 km" },
    tarif: { id: "Rp10.000", en: "IDR 10,000" },
  },
  {
    jarak: { id: "Lebih dari 10 km", en: "More than 10 km" },
    tarif: { id: "Rp20.000", en: "IDR 20,000" },
  },
];

export const CATATAN_BIAYA = {
  id: "Jarak dihitung dari Apotek RS JMC, Jl. Warung Buncit Raya No. 15, Jakarta Selatan.",
  en: "Distance is measured from the JMC pharmacy at Jl. Warung Buncit Raya No. 15, South Jakarta.",
};

export const LANGKAH = [
  {
    judul: { id: "Siapkan resep", en: "Prepare your prescription" },
    isi: {
      id: "Siapkan resep dari dokter beserta alamat lengkap tujuan pengantaran.",
      en: "Have your doctor's prescription ready, along with the full delivery address.",
    },
  },
  {
    judul: { id: "Hubungi apotek", en: "Contact the pharmacy" },
    isi: {
      id: "Kirim pesan ke nomor Apotek RS JMC melalui WhatsApp, atau hubungi Customer Service.",
      en: "Message the JMC pharmacy on WhatsApp, or call Customer Service.",
    },
  },
  {
    judul: { id: "Konfirmasi", en: "Confirmation" },
    isi: {
      id: "Petugas memeriksa ketersediaan obat, lalu menginformasikan total biaya dan ongkos antar.",
      en: "Our staff will check availability, then confirm the total cost and delivery fee.",
    },
  },
  {
    judul: { id: "Obat diantar", en: "Delivery" },
    isi: {
      id: "Obat diantar ke alamat yang Anda berikan sesuai jangkauan layanan.",
      en: "Your medicines are delivered to the address you provided, within the service area.",
    },
  },
];
